var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-data-table_sub"},[_c('x-default-data-table',{attrs:{"x-options":_vm.tableOptions,"x-context":_vm.self,"x-container":_vm.tableContainer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }